export const TRANSFERS = "https://mobile.globalfarm.com.ar:8281/Users/Login?from=TRANSFER"
//export const PEDIDOS = "https://mobile.globalfarm.com.ar:8281/Users/Login?from=PEDIDO"


// WEBPACK FOOTER //
// ./src/config/urlLogins.js